import React, { useEffect } from 'react';
import getContactUsContent from '@kfc-global/react-shared/redux/Actions/ContactUsAction';
import { useSelector, useDispatch } from 'react-redux';
import ContactKFC from 'organisms/ContactUs/Container/AU/Container';
import { StructureData } from 'organisms/StructureDataComponent';
import { getContactKFCData } from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import isEmpty from 'lodash/isEmpty';

const ContactKFCComponent = props => {
  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(
      getContactUsContent({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': 'Contact Us',
          include: '5',
        },
      }),
    );
  }, [dispatch]);

  let segmentedContactUsData = null;

  const allReducerData = useSelector(data => ({
    contactUsContent: data?.contactUsReducer?.response ?? null,
  }));

  if (!isEmpty(allReducerData.contactUsContent)) {
    segmentedContactUsData = getContactKFCData(
      allReducerData.contactUsContent?.contactUsResp?.items?.[0]?.fields ?? {},
    );
  }
  return (
    <React.Fragment>
      {!isEmpty(segmentedContactUsData) && (
        <>
          {segmentedContactUsData.seoTemplate && <StructureData seoTemplate={segmentedContactUsData.seoTemplate} />}
          <ContactKFC contentData={segmentedContactUsData} history={props.history} tenantId={tenantReducer.tenantId} />
        </>
      )}
    </React.Fragment>
  );
};
export default ContactKFCComponent;
